module.exports = __webpack_public_path__ + "static/09-f9a378f9c457201a0ba72e1cb38f7ba7.jpg";